import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGiveawayJoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M21.957 19.06a2.75 2.75 0 0 1-2.696 3.29H5.14a2.75 2.75 0 0 1-2.697-3.29l2.2-11A2.75 2.75 0 0 1 7.34 5.85h1.11a.75.75 0 1 1 0 1.5H7.34a1.25 1.25 0 0 0-1.226 1.005l-2.2 11A1.25 1.25 0 0 0 5.14 20.85h14.12a1.25 1.25 0 0 0 1.226-1.495l-2.2-11a1.25 1.25 0 0 0-1.225-1.005h-1.11a.75.75 0 0 1 0-1.5h1.11c1.31 0 2.44.925 2.696 2.21l2.2 11Z"
    />
    <path
      fill="#F7A600"
      d="M13.04 2.6a.75.75 0 0 0-1.5 0v11.821l-2.51-2.51a.75.75 0 1 0-1.06 1.062l3.79 3.789a.75.75 0 0 0 1.06 0l3.79-3.79a.75.75 0 0 0-1.061-1.06L13.04 14.42V2.6Z"
    />
  </svg>
);
export default SvgTwoColorGiveawayJoin;
